import { useResize } from '@hooks/useResize';
import { portalID } from '@packages/portals/lib/utils';
import { createMemo } from '@packages/react';
import { debounce } from 'lodash';
import React, { ElementType, HTMLAttributes, useRef } from 'react';

export interface MountPointProps extends HTMLAttributes<HTMLElement> {
    name: string;
    component?: ElementType;
}

const Style = {
    display: 'flex',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
};

export const MountPoint = createMemo<MountPointProps>(
    (props) => {
        const { name, component, ...rest } = props;
        const Component = component!;
        const elRef = useRef();

        useResize(
            debounce((e, [el]) => {
                if (el) {
                    document.body.style.setProperty(`--${portalID(name)}__height`, `${el.clientHeight}px`);
                }
            }, 100),
            () => [elRef.current],
        );

        return <Component style={Style} ref={elRef} id={portalID(name)} {...rest} />;
    },
    {
        displayName: 'MountPoint',
        defaultProps: {
            component: 'div',
        },
    },
);
